import { render } from "./tender_users.vue?vue&type=template&id=45f40e58"
import script from "./tender_users.vue?vue&type=script&lang=js"
export * from "./tender_users.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45f40e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45f40e58', __exports__)) {
    console.log('reload')
    api.reload('45f40e58', __exports__)
  }
  
  module.hot.accept("./tender_users.vue?vue&type=template&id=45f40e58", () => {
    console.log('re-render')
    api.rerender('45f40e58', render)
  })

}


export default __exports__